<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'Add Price list' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form novalidate [formGroup]="priceListForm">
      <div class="form-group">
        <label for="name" class="control-label">
          {{ 'Name' | translate }} *
        </label>
        <input
          #priceListName
          type="text"
          class="form-control"
          tabindex="0"
          id="name"
          formControlName="name"
          [class.is-invalid]="
            sent && priceListForm.get('name').hasError('required')
          "
          placeholder="{{ 'Summer sale' | translate }}"
        />
        <span
          class="invalid-feedback"
          *ngIf="sent && priceListForm.get('name').hasError('required')"
        >
          {{ 'global.validators.required.error' | translate }}</span
        >
      </div>

      <div class="from-group">
        <ng-template #clientSearchTemplate let-r="result">
          <span
            ><b>{{ r.name }}</b></span
          ><br />
          <span>{{ r.address }} {{ r.city }}</span>
        </ng-template>

        <label for="clientSearch" class="control-label">
          {{ 'price-lists.price-list-add.client' | translate }}
          <i
            class="fe fe-info"
            ngbTooltip="{{ 'pricelist-add.clientSearch.tooltip' | translate }}"
          ></i>
        </label>
        <div class="input-group input-group-merge">
          <input
            type="text"
            formControlName="clientSearch"
            [editable]="false"
            [focusFirst]="false"
            [ngbTypeahead]="clientSearch"
            [resultTemplate]="clientSearchTemplate"
            (selectItem)="onSelectClient($event)"
            placeholder="{{
              'Search by name, address, tax num., ...' | translate
            }}"
            class="form-control"
            [class.form-control-appended]="
              priceListForm.controls.clientId.value || loading.clients
            "
          />
          <div
            class="input-group-append"
            *ngIf="priceListForm.controls.clientId.value || loading.clients"
          >
            <div
              class="input-group-text text-danger"
              *ngIf="priceListForm.controls.clientId.value"
            >
              <a href (click)="onSelectClient(); (false)">
                <span class="fe fe-x"></span>
              </a>
            </div>
            <div *ngIf="loading.clients" class="input-group-text text-info">
              <span class="fa fa-spinner-third fa-spin"></span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
      {{ 'Cancel' | translate }}
    </button>
    <button class="btn btn-primary" type="button" (click)="onSave()">
      <span>{{ 'global.save' | translate }}</span>
    </button>
  </div>
</div>
